import colors from "../../Theme/base/colors";
import pxToRem from "../../Theme/functions/pxToRem";

const { text, info, brand } = colors;

export default {
  base: {
    backgroundColor: `${brand.main} !important`,
    minHeight: pxToRem(41),
    minWidth: pxToRem(121),
    color: text.main,
    padding: `${pxToRem(10)} ${pxToRem(24)}`,

    "&:hover": {
      backgroundColor: brand.main,
    },

    "&:active, &:active:focus, &:active:hover": {
      opacity: 0.85,
    },

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(16)} !important`,
    },
  },

  small: {
    minHeight: pxToRem(32),
    padding: `${pxToRem(6)} ${pxToRem(16)}`,
    fontSize: pxToRem(14),

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },
  extraSmall: {
    minHeight: pxToRem(32),

    fontSize: pxToRem(14),

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  large: {
    minHeight: pxToRem(41),
    minWidth: pxToRem(325),
    padding: `${pxToRem(16)} ${pxToRem(100)}`,
    fontSize: pxToRem(16),

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  primary: {
    backgroundColor: info.main,

    "&:hover": {
      backgroundColor: info.main,
    },

    "&:focus:not(:hover)": {
      backgroundColor: brand.main,
    },
  },

  secondary: {
    backgroundColor: brand.main,

    "&:hover": {
      backgroundColor: brand.main,
    },

    "&:focus:not(:hover)": {
      backgroundColor: brand.main,
    },
  },
};
